import { IconImage, LoadingSpinnerIcon } from '@/core/features';
import color from '@/core/features/styles/color';

type TravelFormInputProps = {
    error?: {
        iconUrl: string;
        text: string;
    } | null;
    iconUrl?: null | string;
    isLoading: boolean;
    onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    qaId?: string;
    value: string;
};

export default function TravelFormInput({ error, iconUrl, isLoading, onClick, qaId, value }: TravelFormInputProps) {
    const hasError = !!error;

    return (
        <div
            className={'flex justify-center items-center gap-10 w-full bg-white z-1'}
            data-qa-id={qaId}
            onClick={onClick}
            // eslint-disable-next-line no-inline-styles/no-inline-styles
            style={{ height: 48, padding: '14px 12px' }}
        >
            {iconUrl && (
                <IconImage
                    className={`shrink-0 ${!hasError ? 'icon-color-default' : ''}`}
                    height={15}
                    url={hasError ? error.iconUrl : iconUrl}
                    width={15}
                />
            )}
            <div className={'flex justify-between items-center w-full'}>
                <div className={`line-clamp-1 leading-18 ${hasError ? 'text-persian-red' : ''}`}>
                    {hasError ? error?.text : value}
                </div>
                {isLoading && (
                    <LoadingSpinnerIcon
                        color={color('endeavour')}
                        height={16}
                        width={16}
                    />
                )}
            </div>
        </div>
    );
}
